import React from 'react';

import * as S from './styled';

type Props = {
  message?: string,
  over?: boolean,
}

const Spinner = ({ message, over }: Props) => (
  <S.Spinner over={over}>
    <S.Indicator>
      <svg
        className="face"
        width="40"
        height="40"
        viewBox="0 0 9.9156363 11.00856"
        version="1.1"
        id="svg2358"
      >
        <g
          id="layer1"
          transform="translate(-103.89933,-131.98977)"
        >
          <g
            transform="translate(92.743618,131.92063)"
            id="g2916"
          >
            <S.Ellipse
              ry="4.6555977"
              rx="4.7411985"
              cy="6.2054777"
              cx="16.113525"
              id="path2350"
              strokeWidth="0.4332394"
            />
            <S.Path
              id="path2903"
              d="m 15.464976,0.28080239 h 1.293388"
            />
            <S.Path
              id="path2905"
              d="M 16.111476,1.4159326 V 0.35478894"
            />
            <S.Path
              id="path2907"
              d="m 19.841485,1.6554318 0.903902,0.8906225"
            />
            <S.Path
              id="path2909"
              d="M 19.584621,2.7865188 20.169598,2.2356481"
            />
          </g>
        </g>
      </svg>
      <svg
        className="hand"
        width="1.3mm"
        height="6mm"
        viewBox="0 0 1.2922488 4.6688576"
        version="1.1"
        id="svg3529"
      >
        <g
          id="layer1"
          transform="translate(-110.47887,-128.35605)"
        >
          <g
            transform="translate(95.023191,124.96832)"
            id="g3509"
          >
            <S.Ellipse
              ry="0.41468859"
              rx="0.4301244"
              cy="6.5676427"
              cx="16.101807"
              id="path3500"
              strokeWidth="0.43200001"
            />
            <S.Path
              id="path3502"
              d="M 16.101267,3.6024105 V 6.0869384"
            />
            <S.Path
              d="M 16.1023,7.0140196 V 7.8419053"
              id="path3504"
            />
          </g>
        </g>
      </svg>
    </S.Indicator>
    <S.Message>
      {message}
    </S.Message>
  </S.Spinner>
);

Spinner.defaultProps = {
  message: 'Loading... Please wait',
  over: false,
};

export default Spinner;
